import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import ReCAPTCHA from "react-google-recaptcha";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltLeft } from "@fortawesome/free-solid-svg-icons";
import {
  Field,
  Input,
  Error,
  Button,
  Previous,
  FormStepCount,
  StepCountText,
  StepCountGraphics,
  Bar,
  CheckboxWrapper,
  Checkbox,
  Checkmark,
  Label,
} from "../styles/form-step-styles";

const recaptchaKey = process.env.RECAPTCHA_SITE_KEY;
const Step2 = ({
  errors,
  handleFormStep,
  handleCheckbox,
  handleRecaptcha,
  handleInputChange,
  jobTitle,
  jobLocation,
  terms,
}) => {
  const isIe = detect().name === "ie";

  return (
    <Fragment>
      <FormStepCount className="animated fadeIn delay-1" isIe={isIe}>
        <StepCountText>Step 2/3 - Job Info</StepCountText>
        <StepCountGraphics isIe={isIe}>
          <Bar completed />
          <Bar completed />
          <Bar />
        </StepCountGraphics>
      </FormStepCount>
      <Field className="animated fadeInLeft delay-2">
        <Input
          type="text"
          name="jobTitle"
          value={jobTitle}
          spellCheck={false}
          placeholder="The job's title (not your job title) *"
          data-test-id="employer_intro_job_title"
          onChange={(e) => handleInputChange(e)}
        />
        {errors.jobTitle && <Error>{errors.jobTitle}</Error>}
      </Field>
      <Field className="animated fadeInLeft delay-3">
        <Input
          type="text"
          name="jobLocation"
          value={jobLocation}
          spellCheck={false}
          placeholder="The job's location *"
          data-test-id="employer_intro_job_location"
          onChange={(e) => handleInputChange(e)}
        />
        {errors.jobLocation && <Error>{errors.jobLocation}</Error>}
      </Field>
      <Field className="animated fadeInLeft delay-4">
        <CheckboxWrapper>
          <Label data-test-id="employer_intro_terms">
            By submitting this request, you are agreeing to be bound by our{" "}
            <a
              href="https://www.hiring-hub.com/termsofbusiness"
              target="_blank"
              title="Terms of business"
              rel="noopener noreferrer"
            >
              terms of business
            </a>
            <Checkbox
              type="checkbox"
              checked={terms}
              onChange={() => handleCheckbox()}
            />
            <Checkmark />
          </Label>
        </CheckboxWrapper>
        {errors.terms && <Error checkbox>{errors.terms}</Error>}
      </Field>
      <Field>
        <ReCAPTCHA sitekey={recaptchaKey} onChange={() => handleRecaptcha()} />
        {errors.recaptcha && <Error>{errors.recaptcha}</Error>}
      </Field>
      <Field>
        <Button
          type="submit"
          data-test-id="employer_intro_save_button"
          className="animated fadeInUp delay-4"
        >
          Save
        </Button>
        <Previous
          onClick={(e) => handleFormStep(e, "backward")}
          className="animated fadeInUp delay-5"
        >
          <FontAwesomeIcon icon={faLongArrowAltLeft} />
          Previous
        </Previous>
      </Field>
    </Fragment>
  );
};

Step2.propTypes = {
  handleFormStep: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    jobTitle: PropTypes.string,
    jobLocation: PropTypes.string,
    terms: PropTypes.string,
    recaptcha: PropTypes.string,
  }),
  handleInputChange: PropTypes.func.isRequired,
  handleCheckbox: PropTypes.func.isRequired,
  handleRecaptcha: PropTypes.func.isRequired,
  jobTitle: PropTypes.string.isRequired,
  jobLocation: PropTypes.string.isRequired,
  terms: PropTypes.bool,
};

Step2.defaultProps = {
  errors: PropTypes.isNull,
  terms: PropTypes.isFalse,
};

export default Step2;
